import { Box, Flex, Icon, theme } from '@energiebespaarders/symbols';
import { Larger, Medium } from '@energiebespaarders/symbols/helpers';
import { Check } from '@energiebespaarders/symbols/icons/solid';
import { shade } from '@energiebespaarders/symbols/styles/mixins';
import React from 'react';

const HeroChecks: React.FC = () => {
  return (
    <Larger>
      <Flex flexWrap="wrap" pb={5}>
        <Box width="36px">
          <Icon icon={Check} fill={shade(0.33, theme.colors.gold)} />
        </Box>
        <Box width="calc(100% - 36px)" pl={2}>
          Verzekerd van <Medium>definitieve opdrachten</Medium>
        </Box>
        <Box width="36px">
          <Icon icon={Check} fill={shade(0.33, theme.colors.gold)} />
        </Box>
        <Box width="calc(100% - 36px)" pl={2}>
          <Medium>Hogere netto winst</Medium> per opdracht
        </Box>
        <Box width="36px">
          <Icon icon={Check} fill={shade(0.33, theme.colors.gold)} />
        </Box>
        <Box width="calc(100% - 36px)" pl={2}>
          <Medium>Minder werk</Medium> aan acquisitie, administatie en klantcontact
        </Box>
      </Flex>
    </Larger>
  );
};

export default HeroChecks;
